import { Text } from '@change/ds-core-ui';

import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

export const EndorsementsOverview: React.FC = () => {
	const {
		data: { displayName, enrichedData },
	} = useDecisionMakerProfilePageData();

	const summary = enrichedData?.endorsementsOverview?.summary;

	return !summary ? null : (
		<div data-qa="dm-endorsements-overview" className="flex flex-col gap-2">
			<Text variant="heading" className="mb-2">
				Who&apos;s supporting {displayName}?
			</Text>
			<Text variant="body">{summary}</Text>
		</div>
	);
};
